/**
 * Chain-dependent presentation values. Everything the UI shows about "which network" derives from VITE_CHAIN_ID
 * (97 = BNB Smart Chain Testnet, 56 = BNB Smart Chain Mainnet) so a mainnet staging build links to bscscan.com
 * instead of testnet.bscscan.com. VITE_NETWORK_LABEL overrides the badge text (e.g. "BNB Mainnet (staging)").
 */
export const BSC_MAINNET_CHAIN_ID = 56;
export const BSC_TESTNET_CHAIN_ID = 97;

export function expectedChainId(env: ImportMetaEnv = import.meta.env): number {
  const parsed = Number(env.VITE_CHAIN_ID ?? BSC_TESTNET_CHAIN_ID);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : BSC_TESTNET_CHAIN_ID;
}

/** Block explorer origin for a chain id: bscscan.com on 56, testnet.bscscan.com otherwise. */
export function explorerUrlFor(chainId: number): string {
  return chainId === BSC_MAINNET_CHAIN_ID ? 'https://bscscan.com' : 'https://testnet.bscscan.com';
}

/** Explorer origin for the chain this build targets. */
export const EXPLORER_URL = explorerUrlFor(expectedChainId());

/** Default badge text per chain, before any VITE_NETWORK_LABEL override. */
export function defaultNetworkLabel(chainId: number): string {
  return chainId === BSC_MAINNET_CHAIN_ID ? 'BNB Mainnet' : 'BNB Testnet';
}

/** The NETWORK badge text: VITE_NETWORK_LABEL when set (trimmed), else "BNB Mainnet" / "BNB Testnet". */
export function networkLabel(chainId: number, env: ImportMetaEnv = import.meta.env): string {
  const custom = env.VITE_NETWORK_LABEL?.trim();
  return custom ? custom : defaultNetworkLabel(chainId);
}
